


































































































import { defineComponent, computed, PropType } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { useBattery } from "@/utilities/useBattery";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue"),
        SensorPanelLayout: () =>
            import(/* webpackChunkName: "components" */ "./SensorPanelLayout.vue"),
    },
    props: {
        value: { type: Object as PropType<AttachedDeviceModel> },
    },
    setup(props, { emit }) {
        const doorState = computed<string>(() => {
            const st = (props.value as any)?.status;
            if (st === true) return "Open";
            if (st === false) return "Closed";
            return "Unknown";
        });

        const responsive = computed<boolean>(() =>
            props.value?.attachedDeviceId ? props.value.age <= 1 : false
        );

        const isConnecting = computed<boolean>(() => props.value?.isConnecting === true);

        const paired = computed(() =>
            !!(props.value?.attachedDeviceId && props.value.attachedDeviceId !== "")
        );

        const imgSrc = computed(() => require(`@/assets/img/doorsensor.png`));

        const rawBattery = computed(() => props.value?.battery ?? null);

        const { level: batteryLevel, icon: batteryIcon, label: batteryLabel } = useBattery(rawBattery);

        const onEnroll = () => {
            if (props.value) emit('enroll', { typeId: props.value.attachedDeviceTypeId, img: imgSrc.value });
        };

        const onUnpair = () => {
            if (props.value) emit('unpair', { deviceId: props.value.attachedDeviceId })
        }

        return {
            onEnroll,
            onUnpair,
            paired,
            imgSrc,
            responsive,
            doorState,
            isConnecting,
            batteryLevel,
            batteryIcon,
            batteryLabel,
        };
    },
});
